import { useMemo } from 'react'

import { SimpleGrid } from '@mantine/core'
import { useTranslate } from 'react-admin'
import { RoleAttributesApiDTO } from '../../codegen/generated/Api.schemas'
import { useGetApiRoles } from '../../codegen/generated/roles'
import { LXCard } from '../../components/LXCards/LXCard'
import { UsersHelper } from '../../helpers/Users.helper'

type UserRolesCardsProps = {
  availableRoleIds?: RoleAttributesApiDTO['id'][]
  readonly?: boolean
}

export const UserRolesCards = ({
  availableRoleIds = [],
  readonly = false,
}: UserRolesCardsProps) => {
  const t = useTranslate()

  const rolesQuery = useGetApiRoles()

  const roles = useMemo(
    () =>
      (rolesQuery.data?.body ?? [])
        .map(r => ({
          value: r.id,
          label: r.name,
          description: UsersHelper.getPermissionsList(r.permissions, t),
        }))
        .filter(item =>
          availableRoleIds.length > 0 ? availableRoleIds.includes(item.value) : true,
        ),
    [rolesQuery.data?.body, availableRoleIds, t],
  )

  return (
    <SimpleGrid cols={6} spacing="md" verticalSpacing="xl" w="100%" pt="md">
      {roles.map(r => (
        <LXCard key={r.value} roleItem={r} readonly={readonly} />
      ))}
    </SimpleGrid>
  )
}
